module.exports = __webpack_public_path__ + "media/images/themes/dark/epic-games-509e93129eb76fc8420a41d26abd4823.svg";